import { message, Tooltip, Button, Menu } from 'antd';
import { AnimationModal, Tables } from '@/components';

import {AdminUserOrganizeApi} from "gmrfid-service-user-api-manager"
import {AreaApi} from "gmrfid-service-user-api-client"
import { RightOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Wrap } from './style';
import AddForm from './add';
import { arrayToTree, treeDeconstruction } from '../../utils';
import lodash from 'lodash';

const { SubMenu } = Menu;
const IndustryManage = () => {
  const [tableTime, setTableTime] = useState();
  const [fields, setFields] = useState({});
  const [showDrawer, setShowDrawer] = useState(false);
  const [tableObj, setTableObj] = useState({});
  const [visible, setVisible] = useState(false);
  const [modalKey, setModalKey] = useState('');
  const [subMenuKey, setSubMenuKey] = useState();
  const [menuKey, setMenuKey] = useState();
  const [openKeys, setOpenKeys] = useState([]);
  const [data, setData] = useState([]);
  const [PCode, setPCode] = useState(null);
  const [code, setCode] = useState(null);
  const [parentId, setParentId] = useState();
  const [jurisdictionCode, setJurisdictionCode] = useState();
  const [organizationName, setOrganizationName] = useState('');
  const [tableData, setTableData] = useState([]);
  const [selectCode, setSelectCode] = useState({});
  const handleMenuModal = (opt, record) => {
    setVisible(true);
    setModalKey(opt);
    setTableObj(record);
  };

  /**
   * 2026/7/3
   * 新需求：在广元环境下，只展示广元的行政区划，其他区域不展示
   * 原逻辑：在成都，绵阳，泸州环境，展示全数据
   * *****
   * 怎么判断 当前是 哪个环境？看代码发现
   * LoginApi.logo({ key: process.env.NODE_ENV === 'development' ? 'wjmhadmin-dev.jmhvip.com' : window.location.host})
   * 那就是将host传给后端, 后端根据host返回该城市的专属配置信息（标题，版权信息，logo等）,
    * 在LoginApi.logo接口中添加了 localStorage.setItem('appConfig', JSON.stringify((res as any).data || '{}'));
    * 那就根据 标题 来判断是否 含有“广元”两个字，那么就是广元环境
    */
  let appConfigObj: any = {};
  try {
    const appConfigStr = localStorage.getItem('appConfig') || '{}';
    appConfigObj = JSON.parse(appConfigStr);
  } catch {
    appConfigObj = {};
  }

  // 修改当前记录
  const handleEdit = (row) => {
    setTableObj(row);
    setShowDrawer(true);
  };


  const queryAreaData = () => {
    AreaApi.simpleList({
      param: {
        PCode,
      },
    }).then((res) => {
      if (res.data.length) {
        let dataId = res.data.map((it, i) => {
          const obj = it;
          switch (code) {
            case 'CS':
              obj.type = 'CS';
              break;
            case 'QX':
              obj.type = 'QX';
              break;
            case 'JD':
              obj.type = 'JD';
              break;
            case 'SQ':
              obj.type = 'SQ';
              break;
            default:
              obj.type = 'S';
              break;
          }
          obj.isClick = true;
          obj.id = it.code;
          obj.parentId = parentId;
          return obj;
        });

        const openKeysArr = [...openKeys];
        if (parentId) {
          openKeysArr.push(parentId);
        }
        setOpenKeys([...new Set(openKeysArr)]);

        // 广元环境下，初始加载时只展示广元的行政区划，过滤掉其他区域
        if (PCode && appConfigObj?.appConfig?.title?.includes('广元') && dataId[0]?.type === 'CS') {
          dataId = dataId.filter((item) => item.name?.includes('广元'));
        }

        // ====== 改动点：增量更新，不再全量重建 ======
        if (parentId) {
          // 有父节点：找到对应节点，只给它挂 children
          setData((prevData) => {
            const newTree = lodash.cloneDeep(prevData);

            const findAndSetChildren = (nodes) => {
              for (const node of nodes) {
                if (node.id === parentId) {
                  node.children = dataId;
                  return true;
                }
                if (node.children?.length && findAndSetChildren(node.children)) {
                  return true;
                }
              }
              return false;
            };

            findAndSetChildren(newTree);
            return newTree;
          });
        } else {
          // 没有父节点：初始加载，直接设置
          setData(dataId);
        }
      }
    });
  };

  useEffect(() => {
    queryAreaData();
  }, [PCode]);

  const columns = [
    {
      title: '序号',
      align: 'center',
      dataIndex: 'num',
    },
    {
      title: '组织名称',
      align: 'center',
      dataIndex: 'name',
      // render: (text) => <div>{organizationName}级监管</div>,
    },
    // {
    //   title: '用户角色',
    //   align: 'center',
    //   dataIndex: 'name',
    // },
    {
      title: '账号',
      align: 'center',
      dataIndex: 'phone',
    },
    {
      title: '角色类型',
      align: 'center',
      dataIndex: 'supervisionRoleNames',
      render: (_, row) => {
        const supervisionRoleNames = row.supervisionRoleNames || [];
        const str = supervisionRoleNames.join(', ');
        return str;
      },
    },
    {
      title: '用户昵称',
      align: 'center',
      dataIndex: 'userName',
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'entityStatus',
      render: (text) => (
        <div>
          {text === 'NORMAL' && <span>正常</span>}
          {text === 'DELETE' && <span style={{ color: '#FF513D' }}>停用</span>}
        </div>
      ),
    },
    {
      title: '操作',
      dataIndex: 'name',
      align: 'center',
      render: (text, record) => (
        <ul className="operation">
          {record.entityStatus !== 'NORMAL' && (
            <li style={{ color: '#44BB55' }} onClick={() => handleMenuModal('NORMAL', record)}>
              启用
            </li>
          )}
          {record.entityStatus !== 'DELETE' && (
            <li style={{ color: '#FF513D' }} onClick={() => handleMenuModal('DELETE', record)}>
              停用
            </li>
          )}
          <li style={{ color: '#44BB55' }} onClick={() => handleEdit(record)}>
            修改
          </li>
        </ul>
      ),
    },
  ];

  const tablesGroupOption = {
    columns,
    pagination: true,
    tableTime,
    parameterName: 'param',
    setTableData,
    queryTableList: jurisdictionCode ? AdminUserOrganizeApi.getUserAccountByCode : null,
    fields,
    rowKey: 'id',
  };

  // 禁用、启用
  const startStopFn = () => {
    AdminUserOrganizeApi.updateAccount({
      form: {
        id: tableObj?.id,
        entityStatus: modalKey,
      },
    }).then((res) => {
      if (res && res.status === 200) {
        message.success('操作成功');
        setTableTime(Math.random());
        setVisible(false);
      }
    });
  };

  const dom = (arr: any[]) => {
    return arr.map((item, i) => {
      if (item?.children && item?.children.length > 0) {
        return (
          <SubMenu
            key={item.id}
            title={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  background: subMenuKey === item.id ? '#44bb55' : 'none',
                  color: subMenuKey === item.id ? '#fff' : '#666666',
                }}
              >
                <span>{item.name}</span>
              </div>
            }
            onTitleClick={(e) => {
              setSelectCode(item);
              setOrganizationName(item.name);
              setFields({
                jurisdictionCode: item.code,
              });
              setJurisdictionCode(item.code);
              if (item.isClick) {
                const keys = openKeys.findIndex((k) => k === item.id);
                const newKeys = lodash.cloneDeep(openKeys);
                if (keys > -1) {
                  newKeys.splice(keys, 1);
                  setOpenKeys(newKeys);
                } else {
                  setOpenKeys([...newKeys, item.id]);
                }
              } else {
                setPCode(item.code);
                setParentId(item.id);
                setCode(item.type);
              }
              setMenuKey();
              setSubMenuKey(item.id);
            }}
          >
            {dom(item.children)}
          </SubMenu>
        );
      }
      return (
        <Menu.Item
          key={item.id}
          title={item.name}
          onClick={(e) => {
            setSelectCode(item);
            setFields({
              jurisdictionCode: item.code,
            });
            setOrganizationName(item.name);
            setJurisdictionCode(item.code);
            setParentId(item.id);
            let str = '';
            switch (item.type) {
              case 'S':
                str = 'CS';
                break;
              case 'CS':
                str = 'QX';
                break;
              case 'QX':
                str = 'JD';
                break;
              case 'JD':
                str = 'SQ';
                break;
              default:
                break;
            }
            setPCode(item.code);
            setCode(str);
            const keys = openKeys.findIndex((k) => k === item.id);
            const newKeys = lodash.cloneDeep(openKeys);
            if (keys > -1) {
              newKeys.splice(keys, 1);
              setOpenKeys(newKeys);
            } else {
              setOpenKeys([...newKeys, item.id]);
            }
            setMenuKey(item.id);
            setSubMenuKey(item.id);
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: menuKey === item?.id ? '#44bb55' : 'none',
              color: menuKey === item?.id ? '#fff' : '#666666',
            }}
          >
            <span>{item?.name}</span>
            {item.type !== 'SQ' && (
              <div>
                <RightOutlined />
              </div>
            )}
          </div>
        </Menu.Item>
      );
    });
  };
  return (
    <Wrap>
      <div className="left">
        <div className="title">行政区划</div>
        <div style={{ height: 'calc(100% - 48px)', overflow: 'auto' }}>
          <Menu mode="inline" openKeys={openKeys} selectedKeys={subMenuKey || menuKey}>
            {dom(data)}
          </Menu>
        </div>
      </div>
      <div className="right">
        <Button
          className="add"
          onClick={() => {
            if (!jurisdictionCode) {
              message.warning('你还没选择城市及社区');
              return;
            }
            setShowDrawer(true);
          }}
        >
          新建账号
        </Button>
        <div style={{ height: 'calc(100% - 52px)', overflow: 'auto' }}>
          <Tables {...tablesGroupOption} />
        </div>
      </div>
      {showDrawer && (
        <AddForm
          tableData={tableData}
          setTableData={setTableData}
          setFields={setFields}
          data={data}
          setShowDrawer={setShowDrawer}
          showDrawer={showDrawer}
          tableObj={tableObj}
          setTableTime={setTableTime}
          selectCode={selectCode}
          setTableObj={setTableObj}
          jurisdictionCode={jurisdictionCode}
          organizationName={organizationName}
        />
      )}
      {/* --------------启停、删除------------- */}
      {visible && (
        <AnimationModal
          width={350}
          title={modalKey === 'NORMAL' ? '启用' : '禁用'}
          isFooter
          closeCallback={() => {
            setVisible(false);
            setTableObj({});
            setModalKey('');
          }}
          confirmCallback={() => {
            startStopFn();
          }}
        >
          {modalKey !== 'delete' && (
            <h1 className="del_Text">{`确定${modalKey === 'NORMAL' ? '启用' : '禁用'}账号？`}</h1>
          )}
        </AnimationModal>
      )}
    </Wrap>
  );
};

export default IndustryManage;
